import lastManStandingPoster from '../images/last_man_standing.png';
import boardGameNightPoster from '../images/boardgame_night.png';
import feichengwuraoPoster from '../images/feichengwurao.png';

export const upcomingEvents = [
    {
      id: 1,
      image: lastManStandingPoster,
      url: "https://mp.weixin.qq.com/s/OQZJL-9WsirBY7hg2lpbMw"
    },
    {
      id: 2,
      image: boardGameNightPoster,
      url: "https://mp.weixin.qq.com/s/jux5F_m39JHwLmXzSRb-Cg"
    },
    {
      id: 3,
      image: feichengwuraoPoster,
      url: "https://mp.weixin.qq.com/s/y8xtnl4QNxAwq6eLJs4BuQ"
    }

  ];